import moment from "moment";

import { images } from "../../../assets";
import { LeftInfoModalProps } from "../../../components/left-info-modal/left-info-modal-layout";
import { IND_TIPO_RECIBO_DIC, isKeyOfTipoRecibo } from "../../../constants/clientsDebtRecovery";
import { Column, TableProps } from "../../../components/table-simple/table.types";
import { IDebtReceipts, ReciboIndividual } from "../../../services/DebtRecoveryServices.dto";

function formatDate(date: string): string {
  const momentDate = moment(date, "YYYY-MM-DD", true);
  return momentDate.isValid() ? momentDate.format("DD/MM/YYYY") : date;
}

const columns: Column[] = [
  { title: "RECIBO UNICO", key: "COD_RECIBO_UNICO", position: "left" },
  { title: "RECIBO INDIVIDUAL", key: "COD_RECIBO_INDIVIDUAL", position: "left" },
  { title: "DÍGITO CONTROL", key: "NUM_DC_RECIBO_INDIVIDUAL", position: "left" },
  { title: "IMPORTE TOTAL", key: "IMP_IMPORTE_TOTAL", position: "left" },
  { title: "FECHA VENCIMIENTO", key: "FEC_VENCIMIENTO", position: "left" },
  { title: "TIPO RECIBO", key: "IND_TIPO_RECIBO", position: "left" },
  { title: "ASEGURADO", key: "NOM_ASEGURADO", position: "left" },
  { title: "NÚMERO PÓLIZA", key: "NUM_POLIZA", position: "left" },
  { title: "ORDEN", key: "ORDEN", position: "left" },
  { title: "ESTADO", key: "ESTADO", position: "left" },
  { title: "ORIGEN", key: "ORIGEN", position: "left" },
];

export const formatTabsData = (
  data: IDebtReceipts
): { tabs: string[]; tabsData: { [key: string]: TableProps } } => {
  const tabs: Set<string> = new Set();
  const tabsData: { [key: string]: TableProps } = {};

  data.ListaReciboIndividual.forEach((receipt: ReciboIndividual) => {
    const { SUBRAMO } = receipt;
    if (!SUBRAMO) return;

    tabs.add(SUBRAMO);

    const formatedReceipt = {
      ...receipt,
      NOM_ASEGURADO: (receipt.DATOS_POLIZA && receipt.DATOS_POLIZA.NOM_ASEGURADO) || "",
      NUM_POLIZA: (receipt.DATOS_POLIZA && receipt.DATOS_POLIZA.NUM_POLIZA) || "",
      NUM_ORDEN: (receipt.DATOS_POLIZA &&receipt.DATOS_POLIZA.NUM_ORDEN) || "",
      IMP_IMPORTE_TOTAL: receipt.IMP_IMPORTE_TOTAL.replace(".", ","),
      FEC_VENCIMIENTO: formatDate(receipt.FEC_VENCIMIENTO),
      IND_TIPO_RECIBO: isKeyOfTipoRecibo(receipt.IND_TIPO_RECIBO)
        ? IND_TIPO_RECIBO_DIC[receipt.IND_TIPO_RECIBO]
        : receipt.IND_TIPO_RECIBO,
    };

    const { DATOS_POLIZA, ...receiptFlatFormat } = formatedReceipt;
    const row = receiptFlatFormat as unknown as { [key: string]: string | number };
    if (tabsData[SUBRAMO]) {
      tabsData[SUBRAMO].data.push(row);
    } else {
      tabsData[SUBRAMO] = {
        data: [row],
        columns,
      };
    }
  });

  return {
    tabs: Array.from(tabs),
    tabsData,
  };
};

export const MODAL_SEND_DEBT_EMAIL_OK: Partial<LeftInfoModalProps> = {
  active: true,
  img: images.IconContactCollapsedWhite,
  mainTitle: "Petición de recobro enviada",
  mainText: "La petición de recobro se ha enviado satisfactoriamente al email suministrado.",
};

export const MODAL_SEND_DEBT_EMAIL_KO: Partial<LeftInfoModalProps> = {
  active: true,
  img: images.WarningError,
  mainTitle: "No se ha podido enviar la petición de recobro",
  mainText: "Se ha producido un error, verifique que haya ingresado el email correcto.",
};
